import type { GetterTree } from 'vuex'
import type { RootState } from '@/store'
import type { UserState } from './types'
import type { UpdatedDevice, MovedToAnotherDeviceMessage } from '@/types/user'
import { USER_GETTERS } from './types'

interface IUserGetters extends GetterTree<UserState, RootState> {
  [USER_GETTERS.GET_DEVICES_UPDATED](state: UserState): UpdatedDevice[]
  [USER_GETTERS.GET_VIEWED_SUBSCRIPTION_EXPIRED](state: UserState): boolean | null
  [USER_GETTERS.GET_LAST_VIEWED_VERSION](state: UserState): string
  [USER_GETTERS.GET_VISITED](state: UserState): boolean | null
  [USER_GETTERS.GET_MOVED_TO_ANOTHER_DEVICE_MESSAGES](
    state: UserState
  ): MovedToAnotherDeviceMessage[]
  [USER_GETTERS.GET_SHOW_DATA_GAP_LINE](state: UserState): boolean
}

const getters: IUserGetters = {
  [USER_GETTERS.GET_DEVICES_UPDATED](state) {
    return state.settings.devicesUpdated
  },
  [USER_GETTERS.GET_VIEWED_SUBSCRIPTION_EXPIRED](state) {
    return state.settings.viewedSubscriptionExpired
  },
  [USER_GETTERS.GET_LAST_VIEWED_VERSION](state) {
    return state.settings.lastViewedVersion
  },
  [USER_GETTERS.GET_VISITED](state) {
    return state.settings.visited
  },
  [USER_GETTERS.GET_MOVED_TO_ANOTHER_DEVICE_MESSAGES](state) {
    return state.settings.movedToAnotherDeviceMessages
  },
  [USER_GETTERS.GET_SHOW_DATA_GAP_LINE](state) {
    return state.settings.showDataGapLine ?? true
  }
}

export default getters
